import React, {   useState } from 'react'
import {  Form, Input, App,Modal } from 'antd'
import { useBumenAddMutation } from '../../store/DianShangYeWuApi';
import Icon from '../../cpn/Icon';
function DeptAdd(props) {
    const [open,setOpen] = useState(false)
    const{message} = App.useApp();    
    const [form] = Form.useForm(); 
    const [submit] = useBumenAddMutation();
    const [info,setInfo] = useState({       
        'd_qy_id': props.qy_id,
        'd_qy_name': props.qy_name,
        'd_name': '',
        'd_cid': props.yh_id,
        'd_cname': props.yh_name
    })
    
 
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} />
            <Modal
                open={open}
                title='新增部门'
                width={800}
                onCancel={() => {setOpen(false)}} 
                onOk={() => {                    
                    submit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功')   
                            form.resetFields();  
                            setOpen(false);
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败：'+res.data.Message)
                        }
                    }) 
                }}            
            >
                <Form                                
                    form={form}
                    style={{width: '100%' }}
                    layout="horizonal"
                    name="form_client"
                    initialValues={{
                        modifier: 'public',
                    }}
                    labelCol={{ span: 5}}                                 
                >   
                    <Form.Item name="d_name" wrapperCol={{span:10}} required label='名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,d_name:e.target.value}))
                        }}/>
                    </Form.Item>                       
                </Form>
            </Modal>
        </>
    )
}

export default DeptAdd